// reactstrap components

import { Col, Row, FormGroup, Label,
	ModalFooter,
	Modal,
	ModalHeader,
	ModalBody,
	Form,
	Button,
	Nav,
	NavItem
 } from "reactstrap";
import React, { useEffect, useState,useMemo } from 'react';
import { BsCart4 } from "react-icons/bs";
import { HiShoppingCart } from "react-icons/hi";


const AdminNavbar = ({data,onCartClick }) =>
{
const itemNumber = data

const [show,setShow] = useState(false);



const handleClose = () =>{
	setShow(false)
}
const handleopen = () =>{
	setShow(true)
}
const logout = () =>{
	sessionStorage.removeItem("accessToken")
	sessionStorage.removeItem("smsVerified")
	window.location.href="purchaser-auth/login"
}

	useEffect(() => {
		let timeoutId;

		function onUserActivity() {
			if (timeoutId) clearTimeout(timeoutId);

			timeoutId = setTimeout(() => {
				sessionStorage.removeItem('accessToken');
				window.location.href = 'auth/purchaser/logout';
				
			}, 1800000);
		}

		window.addEventListener('mousemove', onUserActivity);
		window.addEventListener('keydown', onUserActivity);

		return () => {
			window.removeEventListener('mousemove', onUserActivity);
			window.removeEventListener('keydown', onUserActivity);
		};
	}, []);



	return (
		<>
			<Nav navbar>
				<NavItem>
					<div className="d-flex align-items-center justify-content-end custom-cart-responsive" >
						<div className={`position-relative me-3 text-dark `}
						 style={{cursor:"pointer"}}
						 onClick={onCartClick}
						 >
							{
								itemNumber?.length > 0 ?
								<p className="mb-0 position-absolute  translate-middle border-blue rounded-circle px-2  text-white" style={{backgroundColor:"#2665F2",right:"-4px",top:"-2px",height:"20px",
									width:"20px",fontSize:"11px",display:"flex",alignItems:"center",justifyContent:"center"}} title={itemNumber?.length}>{itemNumber?.length > 99 ? "99+" : itemNumber?.length > 0 ? itemNumber.length : ""}
                                </p>
								:
								""
							}
								
							<HiShoppingCart  className="fs-3 me-1 mt-1"/>
						</div>
					
					<button className="btn-magnify mb-0 gradient_color btn">
						<span className="d-none d-md-inline" style={{cursor:"pointer"}} onClick={() => handleopen()}><i className="fas fa-sign-out-alt"></i> Logout </span>
					</button>
					</div>
				
				</NavItem>
			</Nav>
			<Modal
        isOpen={show}
        toggle={handleClose}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >

        <ModalBody>
        <Col>
        <img className="modal-img"
            src="/assets/images/exclamation.svg"
            // className="img-fluid"
            alt=""
        />
        <br />
        <br />
        <h1 className="modal-text">Are you sure, you want to Log out..?</h1>
        <br />
        <div className="modal-row d-flex justify-content-center align-items-center">
            <Col md ={1}></Col>
            <Col md={6}>
                <Button className="btn btn-success success-btn" style={{minWidth:"120px"}} onClick={logout}>
                    <span><b>Yes, Logout</b></span>
                </Button>
            </Col>
            <Col className="middle-col" md ={2}></Col>
            <Col md={4}>
            <Button className="btn btn-danger danger-btn" onClick={handleClose} >
                    <span><b>Cancel</b></span>
                </Button>
             </Col>
            <Col md ={1}></Col>
        </div>
        <br />
        </Col>
        </ModalBody>

  </Modal> 
		</>
	);
};

export default AdminNavbar;
